export const SET_TOUR_STEPS = "SET_TOUR_STEPS"
export const START_TOUR = "START_TOUR"
export const DISMISS_TOUR_STEP = "DISMISS_TOUR_STEP"
export const TRIGGER_TOUR_STEP = "TRIGGER_TOUR_STEP"
